import { Component, Input } from '@angular/core'
export interface IContentList {
  link?: string
  alt: string
  imageWebp: string
  image: string
  imageMobileWebp: string
  imageMobile: string
  hyperLink?: string
  hyperLinkText?: string
}
@Component({
  selector: 'flowaccount-tax-invoice-banner-shared',
  templateUrl: './tax-invoice-banner-shared.component.html',
  styleUrls: ['./tax-invoice-banner-shared.component.scss'],
})
export class TaxInvoiceBannerSharedComponent {
  @Input() contentList: IContentList
  @Input() customClass = ''
}
